import { useState, useEffect } from "react";
import { fieldType } from "../../../../../types/form";
import Form from "../../../../../components/Form";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";
import _ from 'lodash';
import { selectUsers } from "src/modules/users/selector";
import { getItemsRequest } from "src/modules/spItems/api";
import { addUsers } from "src/modules/users/actions";
import { RootState } from "src/store/rootReducer";
import Loading from "src/components/Loading";
import { FlexCol } from "src/utils/flexLayouts";
import { approversDependenciesListName, approversListName } from "src/api/config";

type Props = {
  setApprovers: (obj: any) => void;
  openCancelAddCard: boolean;
  setOpenCancelAddCard: (b: boolean) => void;
  typeDocument: number;
  collection: number;
  setBackStep: (b: boolean) => void;
  backStep: boolean;
};

function Step_3(props: Props) {
  const { setApprovers, openCancelAddCard, setOpenCancelAddCard, typeDocument, setBackStep, backStep, collection } = props;
  const approvers = useAppSelector((state) => selectItems(state, approversListName));
  const [approversDependencies, setApproversDependencies] = useState<any>([]);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const dispatch = useAppDispatch();
  const users: any = useAppSelector(selectUsers);
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);

  const [fieldsForm, setFieldsForm] = useState<fieldType[]>([]);

  useEffect(() => {
    if (typeDocument && collection) {
      getItemsRequest({ listName: approversDependenciesListName, filters: { DocType: typeDocument, Collection: collection }, sortOrder: { name: 'Order0', asc: true } }).then((results: any) => {
        if (results.items.length > 0) {
          let usersEmail: any = [];
          // @ts-ignore
          results.items.forEach((item: any) => {
            Object.keys(item).forEach((key) => {
              const field = item[key];
              if (field && !Array.isArray(field) && field.get_email) {
                if (field.get_email()) {
                  usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                }
              }
              if (field && Array.isArray(field) && field.length > 0 && field[0].get_email) {
                field.forEach((user) => {
                  if (user.get_email()) {
                    usersEmail = [...usersEmail, user.get_email().toLowerCase()];
                  }
                });
              }
            });
          });
          usersEmail = _.uniqWith(usersEmail, _.isEqual);
          if (usersEmail.length > 0) {
            let actualEmails: any = [];
            usersEmail.forEach((email: any) => {
              if (!users[email]) {
                actualEmails = [...actualEmails, email.toLowerCase()];
              }
            });
            if (actualEmails) {
              dispatch(addUsers(actualEmails));
            }
          }
        }
        setApproversDependencies([...results.items]);
      });
    }
  }, [typeDocument, collection]);

  useEffect(() => {
    setApprovers({});
    return () => {
      setApproversDependencies([]);
    }
  }, []);

  useEffect(() => {
    //console.log(" --- approversDependencies step_3: ", approversDependencies);
    if (approversDependencies.length > 0) {
      localStorage.setItem('approversDependencies', JSON.stringify(approversDependencies.map((item: any) => {
        return {
          Group: { ID: item.Group.get_lookupId() },
          Order0: item.Order0,
          MultiApprove: item.MultiApprove,
        }
      })));
    }
  }, [approversDependencies]);

  useEffect(() => {
    if (approversDependencies.length > 0 && approvers.length > 0) {
      const approversObj: any = {};
      _.orderBy(approversDependencies, ['Order0'], ['asc']).forEach((approversRowDependencies: any) => {
        const idApproversGroup = approversRowDependencies.Group.get_lookupId();
        const groupApprovers =
          approvers.filter((item) => item.ID === idApproversGroup).length > 0 &&
          approvers.filter((item) => item.ID === idApproversGroup)[0];
        if (groupApprovers) {
          approversObj[groupApprovers.Code] = {
            type: "peoplePicker",
            key: groupApprovers.Code,
            require: true,
            disabled: approversRowDependencies.NotChange,
            width: "w-full",
            title: groupApprovers.Title,
            multiApprove: approversRowDependencies.MultiApprove && "Требуется согласование всей группы" || null,
            placeholder: groupApprovers.Title,
            options:
              approversRowDependencies.Users.length > 0 &&
              approversRowDependencies.Users.map((item: any) => {
                const email = item.get_email().toLowerCase();
                return {
                  value: users[email] && users[email].email || email,
                  label: users[email] && users[email].displayName || item.get_lookupValue(),
                  avatar: users[email] && users[email].avatar || null,
                };
              }),
          };
        }
        if (approversRowDependencies.NotChange && approversRowDependencies.DefaultApprovers && approversRowDependencies.DefaultApprovers.length > 0) {
          setDefaultValues((prevState: any) => {
            return {
              ...prevState, [groupApprovers.Code]: approversRowDependencies.DefaultApprovers.map((item: any) => {
                const email = item.get_email().toLowerCase();
                return {
                  value: users[email] && users[email].email || email,
                  label: users[email] && users[email].displayName || item.get_lookupValue(),
                  avatar: users[email] && users[email].avatar || null,
                  email: users[email] && users[email].email || email,
                  code: groupApprovers.ID
                }
              })
            }
          })
        }
      });
      let fieldsFormUpdate: any = [];
      Object.keys(approversObj).length > 0 &&
        Object.keys(approversObj).map((key: string) => {
          fieldsFormUpdate = [...fieldsFormUpdate, approversObj[key]];
        });
      setFieldsForm(fieldsFormUpdate);
    }
  }, [approversDependencies, approvers, users]);

  return (
    <div className="step_3 md:min-w-[975px] md:max-w-[975px] md:min-h-[75vh]">
      <span className="text-7.5 leading-[38px] font-bold text-black block mb-8">Укажите согласующих</span>
      {statusUsers !== "LOADING" && fieldsForm.length > 0 &&
        <Form
          type="approvers_list"
          textButtonSubmit="Отправить на согласование"
          openCancelAddCard={openCancelAddCard}
          setOpenCancelAddCard={setOpenCancelAddCard}
          setFormData={setApprovers}
          fieldsForm={fieldsForm}
          setBackStep={setBackStep}
          backStep={backStep}
          defaultValues={defaultValues}
        />
        || <FlexCol className="px-7.5 py-5 justify-center items-center gap-5">
          <span className="text-darkblue text-base">Получаем данные согласующих<br />Пожалуйста подождите...</span>
          <Loading />
        </FlexCol>}
    </div>
  );
}

export default Step_3;
